import {
  SELF_ONBOARDING_PATHS,
  SELF_ONBOARDING_ACCESS_ROUTES,
} from "src/consts/Routes/SelfOnboarding";
import { lazy, Suspense, useContext } from "react";
import FooterLinks from "../../Footer/FooterLinks";
import { ThemeValues } from "../../ThemeUsage/theme";
import { ThemeContext } from "../../ThemeUsage/ThemeUsage";
import { Route, Routes, useLocation } from "react-router-dom";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import SelfOnboardingAccessProgressBar from "../../ProgressBar/MicroFrontend/SelfOnboardingAccess";

const AccessFailed = lazy(
  () => import("src/pages/SelfOnboarding/AccessFailed"),
);
const AccessSuccess = lazy(
  () => import("src/pages/SelfOnboarding/AccessSuccess"),
);
const AuthenticationCallback = lazy(
  () => import("src/pages/SelfOnboarding/AuthenticationCallback"),
);
const Access = lazy(() => import("src/pages/SelfOnboarding/Access"));

const SelfOnboardingAccess = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            {SELF_ONBOARDING_ACCESS_ROUTES.includes(pathname) && (
              <SelfOnboardingAccessProgressBar />
            )}
          </Grid>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Access />
                  </Suspense>
                }
                path={SELF_ONBOARDING_PATHS.ACCESS}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <AccessSuccess />
                  </Suspense>
                }
                path={SELF_ONBOARDING_PATHS.ACCESS_SUCCESS}
              />{" "}
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <AccessFailed />
                  </Suspense>
                }
                path={SELF_ONBOARDING_PATHS.ACCESS_FAILED}
              />{" "}
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <AuthenticationCallback />
                  </Suspense>
                }
                path={SELF_ONBOARDING_PATHS.AUTHENTICATION_CALLBACK}
              />{" "}
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default SelfOnboardingAccess;
